import { Expose } from "class-transformer";

export class UnassignPlanningBoardVacationDto {
  @Expose()
  userId: string;
}
